import { render } from "./LaboratoryLayOut.vue?vue&type=template&id=35fa7f24&scoped=true"
import script from "./LaboratoryLayOut.vue?vue&type=script&lang=js"
export * from "./LaboratoryLayOut.vue?vue&type=script&lang=js"

import exportComponent from "/home/jenkins/agent/workspace/prodbqwjw/sy-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35fa7f24"]])

export default __exports__